import { Injectable } from '@angular/core';

import { API_ENDPOINTS, UrlConstants } from '@varsity/commons';
import {
    HttpHelperService, TokenService, EventsSearchResult,
    EventTicketsResponse, PricePoint, Confirmation,
    PurchaseConfirmation, LoggingService, Ticket, TransferRecipient, TransferResponse, FaqItem
} from '@varsity/services';
import { Observable } from "rxjs/Rx";
import { Merchandise } from '../events/events.model';
import { useAnimation } from '@angular/core/src/animation/dsl';
import { Select } from 'ionic-angular';

@Injectable()
export class FaqService {
    constructor(
        private httpHelperService: HttpHelperService,
        private loggingService: LoggingService,
        private tokenService: TokenService
    ) {
        this.loggingService.log('Hello TicketsService Provider');
    }

    getFaqs(productName: string): Observable<FaqItem[]> {
        const url = UrlConstants.tokenBOUrl + API_ENDPOINTS.getFrequentAskedQuestions;
        if (productName && productName.trim().length > 0) {
            let promise = this.httpHelperService
                .get<FaqItem[]>(url, {
                    params: {
                        "X-Token": this.tokenService.getToken(),
                        "Product": productName
                    }
                });

            return promise;
        }

        return Observable.empty<FaqItem[]>();
    }
}



// WEBPACK FOOTER //
// ./src/services/faq/faq.service.ts